import app from './application';

app.$mount('#app');
